import emktPublicConstants from './emktcommon/constant'
import $ from 'jquery'
import { wxShareConfig } from './util/util'
import wx from 'wx'
import weui from 'weui.js'
// 此文件仅保存淘基因小程序相关逻辑，常量定义保存在emktPublicConstants
function wxShare () {
  let link = $.sign.shareUrl
  let imgUrl = emktPublicConstants.publicUrl + '/emktResources/resocurces/img/logo.jpg'
  let share = {}
  share.title = '吉凯基因网上商城这厢有礼了'
  share.desc = '科研资源共享平台,邀你和好友一起拿大礼!'
  share.link = link
  share.imgUrl = imgUrl
  if (link.indexOf('shareCartId') !== -1) {
    share.title = '您的好友帮您挑选好了产品快来看看吧！'
    share.desc = '一键查收即可购买，省时省力又优惠'
  }
  wxShareConfig(share, function () {
    console.log(link)
  }, function () {
    console.log('fail')
  })
}

/**
 * 小程序下载合同文本
 * @param orderDetail
 */
function wxDownloadOrderText (orderDetail) {
  weui.loading('加载中')
  // window.gcapi('getOrderTextFiles', orderDetail.id).then((res) => {
  const fileName = `合作协议-${orderDetail.orderNo}.pdf`
  // const fileSize = res.body.result[0].fileSize
  weui.loading('加载中').hide()
  wx.miniProgram.navigateTo({
    url:
      '/pages/pdf/pdfPage?comeFrom=contract' +
      '&pdfName=' +
      fileName +
      '&orderId=' +
      orderDetail.id
  })
  console.log(
    '/pages/pdf/pdfPage?comeFrom=contract' +
    '&pdfName=' +
    fileName +
    '&orderId=' +
    orderDetail.id
  )
  // })
}
/**
 * 小程序下载出货单word
 * @param contractNo
 */
function wxDownloadExpressSheet (contractNo) {
  const fileName = `出货单-${contractNo}.docx`
  const expressUrl = '/pages/pdf/pdfPage?comeFrom=express' +
    '&pdfName=' +
    fileName +
    '&pdfSize=' +
    '&contractNo=' +
    contractNo
  console.log(
    expressUrl
  )
  wx.miniProgram.navigateTo({
    url: expressUrl
  })
}
export default {
  ...emktPublicConstants,
  wxShare,
  wxDownloadOrderText,
  wxDownloadExpressSheet
}



// WEBPACK FOOTER //
// ./src/emkt.js